import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class SettingsEvisionRoute extends AuthenticatedRoute {}
